// extracted by mini-css-extract-plugin
export var chevron = "VerticalMarketingSteps-module--chevron--44854";
export var chevronLast = "VerticalMarketingSteps-module--chevron--last--a8485";
export var circle = "VerticalMarketingSteps-module--circle--64474";
export var content = "VerticalMarketingSteps-module--content--c2619";
export var main = "VerticalMarketingSteps-module--main--16b78";
export var separator = "VerticalMarketingSteps-module--separator--8234d";
export var side = "VerticalMarketingSteps-module--side--ac1e4";
export var step = "VerticalMarketingSteps-module--step--52aae";
export var steps = "VerticalMarketingSteps-module--steps--21077";